import { action } from 'satcheljs';
import { OptionQuickComponentSettings } from 'owa-options-core';

export default action(
    'ON_QUICK_OPTION_TOGGLE',
    (isToggledOn: boolean, quickOptionSetting: OptionQuickComponentSettings, key: string) => ({
        isToggledOn,
        quickOptionSetting,
        key,
    })
);
